<template>
  <div class="detail-page">
    <Breadcrumb :tabTitle="titleId"></Breadcrumb>
    <div class="meeting">
      <span v-if="type.length==0">暂无分类</span>
       <span v-for="(item, index) in type" @click="tabClick(item.article_name)" :key="index">{{item.article_name}}({{item.article_count}})</span>
    </div>
    <img src="http://aite.cnaite.cn/data/upload/shop/adv/06322551877776855.jpg" alt="" style="margin-bottom: 40px;">
    <div class="com_box">
      <DetailItem :dataList="list" :comments="commentsList"></DetailItem>
      <Rank></Rank>
    </div>
  </div>
</template>
<script>
import Breadcrumb from './Breadcrumb'
import Rank from './Rank'
import DetailItem from './DetailItem'
import axios from 'axios'
import Qs from 'qs'
export default {
  components: {
    Breadcrumb, Rank, DetailItem
  },
  data(){
    return {
      list:{},
      commentsList:[],
      type:[],
      titleId:0
    }
  },
  computed:{
    detailId(){
      return this.$route.query.id;
    },
    classId(){
      this.titleId = this.$route.query.classId;
      return this.$route.query.classId;
    }
  },
  methods:{
    tabClick(name){
      this.$router.push({path:`/sxy/commerce/${this.classId}`,query:{name:name}})
    },
    // 获取文章详情
    getDetail(){
      axios.post('/ajax/ArchiveShowJson.ashx',Qs.stringify({id:this.detailId})).then(res=>{
        this.list = res.data;
      })
    },
    // 分享
    // getComment(){
    //   axios.post('/ajax/App_ArchiveShow.ashx',Qs.stringify({id:this.detailId,action:'zan'})).then(res=>{
    //     if(res.data){
    //       this.commentsList = res.data;
    //     }
    //   })
    // },
    // 获取文章类型
    getCommentType(){
      let url = encodeURI(`/ajax/App_ArchiveClass.ashx?class_id=${this.classId}&nums=10&action=article_count`)
      axios.post(url).then(res=>{
        this.type = res.data;
      })
    }
  },
  created(){
    this.getDetail();
    // this.getComment();
    this.getCommentType();
  },
}
</script>
<style scoped lang="scss">
.detail-page {
  margin: 0 auto;
  width: 1200px;
  .meeting {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    border: 1px solid #c9deec;
    padding:10px;
    span {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: #0053a4;
      cursor: pointer;
      width: 20%;
    }
    span:hover {
      color: #ff6c00;
    }
  }
  .com_box {
    display: flex;
    justify-content: space-between;
  }
  .page {
    height: 54px;
    display: flex;
    justify-content: flex-end;
    line-height: 54px;
    margin-top: 20px;
  }
}
</style>